/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { css } from "@panda/css";

export const defaultButtonStyles = css({
	borderRadius: "eds.borderRadius.full",
	textStyle: "uiMD",
	"&.secondary": {
		border: "1px solid",
		borderColor: "eds.border.subtle",
		background: "eds.palette.transparent.light.005",
		_hover: {
			background: "eds.palette.transparent.light.005",
			borderColor: "eds.border.default",
		},
	},
	"&.contrast": {
		_hover: {
			borderColor: "eds.fill.contrast.hover",
		},
	},
	smDown: {
		borderRadius: "eds.borderRadius.full",
	},
});
